import { SplitFeatureLoader } from './SplitFeatureLoader';
import { LocalFeatureLoader } from './LocalFeatureLoader'; // set singleton provider

export var featureLoader;
export function setupFeatures(options) {
  if (!featureLoader) {
    if (options) {
      var localMode = options.localMode;

      if (localMode) {
        featureLoader = new LocalFeatureLoader(options);
        return featureLoader;
      }
    }

    featureLoader = new SplitFeatureLoader(options);
  }

  return featureLoader;
}
export function getFeatureLoader(options) {
  if (!featureLoader) {
    return setupFeatures(options);
  }

  return featureLoader;
}
export function setFeatureLoader(someFeatureLoader) {
  featureLoader = someFeatureLoader;
}
export function isFeatureEnabled(name) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return getFeatureLoader().isFeatureEnabled(name, context, options);
}
export function getFeature(name) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return getFeatureLoader().getFeature(name, context, options);
}
export function getFeatures(names) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return getFeatureLoader().getFeatures(names, context);
}